<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .page-type-article
        .paragraph-product-video
            &__container
                max-width: 45.625rem
                padding: 0

                .title--5
                    font-size: 1.125rem
                    line-height: 1.6875rem
                    font-weight: 700
                    margin-bottom: 0.625rem

                    &:before
                        display: none


    .paragraph-product-video

        &__container
            +container2

        &__youtube
            position: relative
            height: 40rem
            background-size: cover
            background-position: center

            +media("<=desktop")
                height: 27rem

            +media("<=tablet")
                height: 22rem

            +media("<=phone")
                height: 10rem

            .play-color
                fill: white

            svg
                width: 6rem
                height: 6rem
                position: absolute
                left: calc(50% - 3rem)
                top: calc(50% - 3rem)
                cursor: pointer
                +media("<=phone")
                    width: 3rem
                    height: 3rem
                    left: calc(50% - 1.5rem)
                    top: calc(50% - 1.5rem)



</style>

<script>

    import URI from 'urijs'
    import cookies from '../../../mixins/cookies';
    import $ from "jquery";

    export default  {

        props: [ 'url' ],
        mixins: [ cookies ],

        data() {
            return {
                isPlaying: false
            }
        },

        computed: {
            showVideo() {
                return this.isYoutubeAuthorized && this.isPlaying;
            },
            showPlayButton() {
                return this.isYoutubeAuthorized && !this.isPlaying;
            },
            youtubeVideoId: function() {
                let string = URI(this.url).search();
                let split = string.split("v=");
                return split[1];
            }

        },

        methods: {
            play() {
                this.isPlaying = true;
            },
        },

        mounted() {
          const tacDiv = this.$refs["tac-container"];
          tacDiv.setAttribute("videoID", this.youtubeVideoId);

          let elem = $(this.$el).find('.paragraph-product-video__youtube').css('background-image');
            if (elem === 'none') {
                this.play();
            }
        }

    }

</script>
